
const Label : React.FC<{ text: string }> = ({ text }) => {
    return (
        <div>
            <span className="label">{text}</span>
        </div>
    )
}

export default Label;